module.exports = __webpack_public_path__ + "static/media/carteFrance.748ff3bd.svg";